/**
 * Unlock sessions (CSO review of PR #95, a J-3705 prerequisite). An `UnlockSession` is the
 * capability a `VaultDataSource` needs before it will load. Only an unlocker issues one, on a
 * successful unlock, and the shell revokes it on every lock path. A data source checks
 * `isLiveSession` and refuses anything else, so a look-alike object, a missing session or one
 * from before the last lock reads nothing.
 *
 * The registry is a WeakSet: it never keeps a session alive on its own.
 */
import type { UnlockSession } from "../contract.js";

const live = new WeakSet<object>();

export function issueSession(method: UnlockSession["method"]): UnlockSession {
  const session: UnlockSession = Object.freeze({ method });
  live.add(session);
  return session;
}

export function isLiveSession(session: unknown): session is UnlockSession {
  return typeof session === "object" && session !== null && live.has(session);
}

export function revokeSession(session: UnlockSession | null): void {
  if (session) live.delete(session);
}
